const prefix = '/opening-times';
const prefixAuth = '/auth';
const prefixAccount = '/account';
const prefixOffice = '/office';

const ApiRoutes = {
  GetOpeningTimes: prefix,
  SaveWeeklyOpeningTime: prefix + '/weekly',
  SaveSpecificOpeningTime: prefix + '/specific',
  DeleteSpecificOpeningTime: prefix + '/specific/{id}',
  SaveUnavailablePeriod: prefix + '/unavailable',
  DeleteUnavailablePeriod: prefix + '/unavailable/{id}',

  GetConnectedCalendars: prefixAuth + '/calendars',
  DisconnectCalendar: '/calendar/{provider}',

  GetAuthUrl: '/calendar/{provider}/get-auth-url',
  ProviderCallback: prefixAuth + '/{provider}/callback',

  GetMyCalendars: '/me/calendars',
  UpdateMyCalendar: '/me/calendars/{id}',
  GetCalendarsNeedsReconnect: '/me/calendars/needs-reconnect',

  GetAccountInfo: prefixAccount,
  UpdateAccountInfo: prefixAccount,
  UpdatePassword: prefixAccount + '/password',
  ReadMyBookings: prefixAccount + '/bookings',

  GetOfficeInfo: prefixOffice,
  UpdateOfficeInfo: prefixOffice,

  UpdatePushSubscription: prefixAccount + '/push-subscription',

  GetNotificationPreferences: prefixAccount + '/preferences',
  UpdateNotificationPreferences: prefixAccount + '/preferences',

  GetBookingSettings: prefixAccount + '/booking-settings',
  UpdateBookingSettings: prefixAccount + '/booking-settings',

  MarkOnboardingConversionFired: prefixAccount + '/onboarding-conversion-fired',
};

export default ApiRoutes;
